export const theme = {
  colors: {
    primary: {
      main: '#6366F1',
      light: '#818CF8',
      dark: '#4F46E5',
      blue: '#3b82f6',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    secondary: {
      main: '#EC4899',
      light: '#F472B6',
      dark: '#DB2777',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    },
    success: {
      main: '#10B981',
      light: '#34D399',
      dark: '#059669',
    },
    warning: {
      main: '#F59E0B',
      light: '#FCD34D',
      dark: '#D97706',
    },
    error: {
      main: '#EF4444',
      light: '#F87171',
      dark: '#DC2626',
    },
    background: {
      primary: '#0F172A',
      secondary: '#1E293B',
      tertiary: '#334155',
      card: 'rgba(30, 41, 59, 0.5)',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    text: {
      primary: '#F1F5F9',
      secondary: '#CBD5E1',
      tertiary: '#94A3B8',
    },
    chart: {
      stroke: '#3b82f6',
      strokeSecondary: 'rgb(147, 51, 234)',
      background: 'rgba(147, 51, 234, 0.1)',
      grid: 'rgba(148, 163, 184, 0.1)',
      gridLight: 'rgba(209, 213, 219, 0.3)',
      gridDark: 'rgba(75, 85, 99, 0.6)',
      axisLabels: '#94A3B8',
      tooltipBg: 'rgba(30, 41, 59, 0.95)',
      tooltipBorder: 'rgba(255, 255, 255, 0.1)',
    },
    border: {
      main: '#334155',
      light: '#475569',
    },
  },
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
  },
  typography: {
    fontFamily: {
      display: 'Space Grotesk, Inter, sans-serif',
      body: 'DM Sans, Inter, sans-serif', 
      mono: 'Geist Mono, ui-monospace, monospace',
    },
    fontSize: {
      xs: '0.75rem',   // 12px
      sm: '0.875rem',  // 14px
      base: '1rem',    // 16px
      lg: '1.125rem',  // 18px
      xl: '1.25rem',   // 20px
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
    },
  },
  animations: {
    bounce: 'bounce 1s infinite',
    pulse: 'pulse 2s infinite',
    fadeIn: 'fadeIn 0.5s ease-in',
    slideIn: 'slideIn 0.3s ease-out',
    float: 'float 3s ease-in-out infinite',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    glow: '0 0 20px rgba(99, 102, 241, 0.5)',
  },
};